import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { SOCIAL_MEDIA_CONFIG } from '../../../services/utilityFunctions';
import AcademyConfigProp from '../propTypes/academyConfig';
import TermsProp from '../../../commonComponents/propTypes/termsProp';
import translate from '../../../commonComponents/translate';
import ShareIcon from './ShareIcon';
import MailIcon from './MailIcon';
import ConfigsContext from '../../../contextProviders/ConfigsContext';

function SupportSection({ t, academyConfig, terms }) {
  const { organization } = useContext(ConfigsContext);
  const { supportEmail } = academyConfig || {};
  const socialMedia = academyConfig?.socialMedia || [];
  const companyLinks = academyConfig?.companyLinks || [];

  const existLinks =
    organization?.termsAndConditions ||
    terms?.termsLink ||
    organization?.privacyPolicy ||
    terms.privacyLink;

  return (
    <div className="landing-support-section shop-main-support-section">
      <div className="landing-footer-subsection shop-main-footer-subsection">
        <MailIcon />
        <div className="landing-footer-subsection-text shop-main-footer-subsection-text">
          <h6 className="landing-footer-subtitle shop-main-footer-subtitle">
            {t('landing_support_title')}
          </h6>
          <a
            href={`mailto:${supportEmail}`}
            className="landing-footer-description shop-main-footer-description"
          >
            {supportEmail}
          </a>
        </div>
      </div>
      {socialMedia.length > 0 && (
        <div className="landing-footer-subsection shop-main-footer-subsection">
          <ShareIcon />
          <div className="landing-footer-subsection-text shop-main-footer-subsection-text">
            <h6 className="landing-footer-subtitle shop-main-footer-subtitle">
              {t('landing_social_title')}
            </h6>
            <div className="landing-footer-social-links shop-main-footer-social-links">
              {socialMedia.map(s => (
                <a
                  key={s.link}
                  href={s.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="landing-footer-social-link shop-main-footer-social-link"
                  title={SOCIAL_MEDIA_CONFIG[s.site].name}
                >
                  <i className={SOCIAL_MEDIA_CONFIG[s.site].icon} />
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
      {existLinks && (
        <div className="landing-footer-link-list-section shop-main-footer-link-list-section">
          <h5 className="landing-footer-link-list-title shop-main-footer-link-list-title">
            {t('landing_usefulLinks')}
          </h5>
          {terms?.termsLink || organization?.termsAndConditions ? (
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="landing-footer-link-item shop-main-footer-link-item"
              href={'/terms-and-conditions' || terms?.termsLink}
            >
              {t('landing_termsOfUse')}
            </a>
          ) : null}
          {terms?.privacyLink || organization?.privacyPolicy ? (
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="landing-footer-link-item shop-main-footer-link-item"
              href={'/privacy-policy' || terms?.privacyLink}
            >
              {t('landing_privacyPolicy')}
            </a>
          ) : null}
        </div>
      )}
      {companyLinks.length > 0 && (
        <div className="landing-footer-link-list-section shop-main-link-list-section">
          <h5 className="landing-footer-link-list-title shop-main-footer-link-list-title">
            {t('landing_company')}
          </h5>
          {companyLinks.map(c => (
            <a
              target="_blank"
              rel="noopener noreferrer"
              key={c.link}
              className="landing-footer-link-item shop-main-footer-link-item"
              href={c.link}
            >
              {c.name}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

SupportSection.propTypes = {
  t: PropTypes.func.isRequired,
  academyConfig: PropTypes.shape(AcademyConfigProp.propType).isRequired,
  terms: PropTypes.shape(TermsProp.propType),
};

SupportSection.defaultProps = {
  terms: null,
};

export default translate(SupportSection);
